// extracted by mini-css-extract-plugin
export var mt0 = "fp-hR";
export var mt1 = "fp-iR";
export var mt2 = "fp-jR";
export var mt3 = "fp-kR";
export var mt4 = "fp-lR";
export var mt5 = "fp-mR";
export var mt6 = "fp-nR";
export var notificationBar = "fp-oR";
export var notificationBarPlaceholder = "fp-pR";
export var notificationBar__body = "fp-qR";
export var notificationBar__left = "fp-rR";
export var notificationBar__left__content = "fp-sR";
export var notificationBar__left__contentLoading = "fp-tR";
export var notificationBar__left__content__cta = "fp-vR";
export var notificationBar__left__content__text = "fp-uR";
export var notificationBar__right = "fp-wR";
export var notificationBar__right__icon = "fp-yR";
export var notificationBar__right__link = "fp-xR";